import { readAuthSession } from '../components/authSessionStore'

/**
 * 合并 `fetch` 的 `headers`：在存在会话或显式传入 `token` 时写入 `ba-user-token`（未显式设置时注入）。
 *
 * @param inputHeaders - `RequestInit.headers`
 * @param explicitToken - 优先于 `readAuthSession()` 的 token（避免同 tab 内刚写入尚未同步等边界）
 * @returns 新的 `Headers` 实例
 */
export function mergeBaUserTokenHeaders(inputHeaders?: HeadersInit, explicitToken?: string | null): Headers {
  const headers = new Headers(inputHeaders ?? undefined)
  const token = (explicitToken?.trim() || readAuthSession()?.token?.trim()) ?? ''
  if (token && !headers.has('ba-user-token')) {
    headers.set('ba-user-token', token)
  }
  return headers
}

/**
 * 与原生 `fetch` 相同，但自动附加 `ba-user-token`（与 BuildAdmin `get_auth_token(['ba','user','token'])` 对齐）。
 *
 * @param input - 请求 URL 或 `Request`
 * @param init - `fetch` 第二参数
 * @param explicitToken - 可选；传入时优先作为 `ba-user-token`
 */
export function fetchWithBaUserToken(
  input: RequestInfo | URL,
  init?: RequestInit,
  explicitToken?: string | null,
): Promise<Response> {
  const headers = mergeBaUserTokenHeaders(init?.headers, explicitToken)
  return fetch(input, { ...init, headers })
}
